import { Facebook, FacebookRounded, GitHub, Instagram, LinkedIn, Twitter, WhatsApp, YouTube } from '@mui/icons-material'
import React, {useState, useEffect} from 'react'
import { FaMailBulk, FaMap, FaMapMarkerAlt, FaMapPin, FaPhone } from 'react-icons/fa'
import Swal from 'sweetalert2';

const Contact = () => {
    const [data, setData] = useState();

    const handleChange = (e) => {
        setData({...data, [e.target.name]: e.target.value});
    }


    useEffect(() => {
        console.log(data);
    }, [data])
  return (
    <div className='home-contact' 
    style={{ 
        // backgroundColor: 'yellow'
     }}>
        
       <div className='container'>
       
               
                <div className=''>
                    <div className='row justify-content-center'>
                    <p className='small-header mt-5 text-center'>GET IN TOUCH </p>
                        {/* <p className='small-header mt-5 text-center'> Contact Info </p> */}
                        {/* <div className='d-flex justify-content-center '> */}
                            <div className='col-lg-6 col-md-6 col-12'>
                                <p className='text-muted ms-3'> <FaPhone/> <b className='ms-2'>Phone</b> </p>
                                <p className='text-muted ms-3'>
                                    +234 8138282448
                                </p>
                            </div>
                            <div className='col-lg-6 col-md-6 col-12'>
                                <p className='text-muted ms-3'> <FaMailBulk /> <b className='ms-2'>Email</b> </p>
                                <p className='text-muted ms-3'>
                                   uselite4199@gmail.com
                                </p>
                                <p className='text-muted ms-3'>
                                   uselite@uxtech.com.ng
                                </p>

                            </div>
                        {/* </div> */}
                    </div>
                    <hr/>

                </div>
       </div>
        <div className='col-12 d-flex justify-content-center'
        style={{ 
            backgroundColor: '#202421'
         }}
        >
            <div className='p-3 my-2'
            style={{ 
                backgroundColor: 'white',
                borderRadius: '20px',
                // height: '150px',
                padding: 3
            }}
            >
                {/* <p className='small-header'> FOLLOW US ON FACEBOOK.</p> */}
                <div className='d-flex align-items-end'
                onClick={() => {
                        
                    }}
                >
                    <a 
                    style={{ color: 'inherit' }}
                    href='http://www.github.com/uselite' target='_blank' >
                    {/* <Facebook fontSize='large'/> */}
                    <GitHub fontSize='large' 
                    
                    />
                    </a>
                    {/* <a 
                    style={{ color: 'inherit' }}
                    href='#'
                    style={{ 
                        color: 'navyBlue'
                    }}
                    >Click  to visit Kin Nupe Facebook page </a> */}
                </div>
            </div>
            <div className='p-3 my-2'
            style={{ 
                backgroundColor: 'whiteSmoke',
                borderRadius: '20px',
                // height: '150px',
                padding: 3
            }}
            >
                {/* <p className='small-header'> FOLLOW US ON INSTAGRAM.</p> */}
                <div className='d-flex align-items-end'
                onClick={() => {
                   
                }}
                >
                     <a 
                     style={{ color: '#0077B5' }}
                     href='https://www.linkedin.com/in/usman-abubakar-a62061226/' target='_blank'>
                    <LinkedIn fontSize='large' 
                    
                    />
                    </a>
                </div>
            </div>
            <div className='p-3 my-2'
            style={{ 
                backgroundColor: 'whiteSmoke',
                borderRadius: '20px',
                // height: '150px',
                padding: 3
            }}
            >
                {/* <p className='small-header'> FOLLOW US ON TWITTER(X).</p> */}
                <div className='d-flex align-items-end'
                onClick={() => {
                    
                }}
                >
                    <a 
                    style={{ color: '#075e54' }}
                    href='https://api.whatsapp.com/send?phone=2348138282448' target='_blank'>
                    <WhatsApp fontSize='large' 
                    
                    />
                    </a>
                    {/* <a href='#'
                    style={{ 
                        color: 'navyBlue'
                    }}
                    >Click to visit Kin Nupe Twitter(X) page </a> */}
                </div>
            </div>
        </div>
    </div>
  )
}

export default Contact